import { cn } from "@/lib/utils";
import { SECTION_CARD_CLASS } from "./constants";

export function StyleSection({
  title,
  description,
  children,
  className,
}: {
  title: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <section className={cn(SECTION_CARD_CLASS, className)}>
      <div className="space-y-0.5 border-b border-slate-100 pb-3">
        <h3 className="text-sm font-semibold text-slate-900">{title}</h3>
        {description ? (
          <p className="text-xs leading-relaxed text-slate-500">{description}</p>
        ) : null}
      </div>
      {children}
    </section>
  );
}
